import template from './empty.html';
import './empty.styl';

const emptyComponent = {
  template
};

export default emptyComponent;


/** WEBPACK FOOTER **
 ** ./frontend/components/utility/empty/empty.component.js
 **/